import React from "react";
import { UserProfileView as UserProfileViewV2 } from "../../components/userProfile/v2/UserProfileView";

export const UserProfileRoute: React.FC = () => {
  return <UserProfileViewV2 />;
};
